import { Action } from 'redux';
import { ConfigData, getConfig } from '../config';
import initialState from '../initialState';

export enum ConfigActionTypes {
    CHANGE = '[Config] Change',

}

export interface IConfigStore {
    data: ConfigData;
    active: string;
    debug: boolean;
    availables: string[];
}

export default (state: IConfigStore = initialState.config, action?: Action<ConfigActionTypes> & { payload: ConfigData, active: string }): IConfigStore => {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case ConfigActionTypes.CHANGE:
            return { ...state, data: action.payload, active: action.active };

        default:
            return state;
    }
};

export class ConfigActions {


    change(newConfig: string) {

        console.log('chaning configuration to ', newConfig);
        const toSet = getConfig(newConfig);
        if (toSet) {
            return { type: ConfigActionTypes.CHANGE, payload: toSet, active: newConfig };
        } else {
            throw new Error(`Key ${newConfig} not found`);
        }
    }


}



// WEBPACK FOOTER //
// ./src/store/config.ts